import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design'
import VueClipboard from 'vue-clipboard2'
import 'view-design/dist/styles/iview.css'

// 模块功能操作id
import menu from './menu.config.js'

let apiPath = process.env.NODE_ENV === 'production' ? 'http://api.zjyumai.com/' : 'http://api.zjyumai.com/'
// let socketPath = process.env.NODE_ENV === 'production' ? 'http://116.62.57.3:9001/' : 'http://localhost:9001/'
// if (process.env.NODE_ENV === 'production') {
//   Vue.use(VueSocketio, socketio(socketPath), store)
// }
Vue.use(VueClipboard)

var browser = {
  versions () {
    var u = navigator.userAgent
    // var app = navigator.appVersion
    return {
      // 移动终端浏览器版本信息
      trident: u.indexOf('Trident') > -1, // IE内核
      presto: u.indexOf('Presto') > -1, // opera内核
      webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或uc浏览器
      iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, // 是否iPad
      webApp: u.indexOf('Safari') === -1 // 是否web应该程序，没有头部与底部
    }
  },
  language: (navigator.browserLanguage || navigator.language).toLowerCase()
}
var isWeixin = function () {
  if (browser.versions().mobile) {
    // 判断是否是移动设备打开。browser代码在下面
    var ua = navigator.userAgent.toLowerCase()
    if (ua.match(/micromessenger/i) === null) return false
    // 获取判断用的对象
    return ua.match(/micromessenger/i).indexOf('micromessenger') >= 0
  }
  return false
}
var is_Wechat = isWeixin()
Vue.prototype.$isNotification = false

if (!is_Wechat) {
  // Notification.requestPermission(function (permission) {
  //   if (permission === 'granted') {
  //     Vue.prototype.$isNotification = true
  //     // console.log('用户允许通知')
  //   }
  // })
}

Vue.prototype.apiPath = apiPath
Vue.prototype.$menu = menu
Vue.prototype.$layoutVisible = true
Vue.prototype.$routeTo = function (path) {
  this.$router.push({ path: `${path}` })
}
Vue.prototype.isWechat = is_Wechat

Vue.use(VueClipboard)
Vue.use(ViewUI)
Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
